{
    "404": "¡Oh, no! ¡Hemos buscado por el mar y no encontramos tu página!",
    "appError": {
        "title": "Algo salió mal",
        "description": "La aplicación ha experimentado un problema inesperado. Intenta recargarla o regresa a tu espacio de trabajo. Si el problema persiste, ponte en contacto con el servicio de asistencia.",
        "home": "Volver al espacio de trabajo"
    }
}
